export class PeriodSelectorModel{
    constructor(public startDate: string, public endDate: string, public sharedGUID: string, public GUID: string){
    }
}



// WEBPACK FOOTER //
// ./src/app/shared/models/period-selector-model.ts